import { Menu, MenuItem, MenuList } from '@mui/material'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import { Fragment } from 'react/jsx-runtime'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import ApproveModal from '../modals/ApproveModal'
import DeclineModal from '../modals/DeclineModal'
import CommentModal from '../modals/CommentModal'
import { ReadTaskStatus, User } from '@common/config/api/client'
import ReopenModal from '../modals/ReopenModal'
import CopyReReadModal from '../modals/CopyReReadModal'
import CopyEmptyReReadModal from '../modals/CopyEmptyReReadModal'
import CopyIntraReadModal from '../modals/CopyIntraRead'

export default function PopupMenuList({
  task_id,
  task_status,
  read_pseudo_id,
  study_id,
  reader,
  comment,
}: {
  task_id: string
  task_status: ReadTaskStatus
  read_pseudo_id: number
  study_id: string
  reader?: User
  comment?: string
}) {
  const isTaskPending = task_status === 'REOPENED_PENDING_APPROVAL'

  return (
    <PopupState variant="popover">
      {(popupState) => (
        <Fragment>
          <MoreVertRoundedIcon
            fontSize="small"
            {...bindTrigger(popupState)}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                borderRadius: '50%',
                backgroundColor: 'background.default',
              },
            }}
            data-testid="popup-menu-icon"
          />
          <Menu
            {...bindMenu(popupState)}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            data-testid="popup-menu-list"
          >
            <MenuList
              sx={{
                width: 188,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                paddingY: 0.5,
                outline: 'none',
              }}
            >
              {isTaskPending ? (
                <Fragment>
                  <MenuItem
                    sx={{
                      width: '100%',
                    }}
                    data-testid="popup-menu-list-item-reopen"
                  >
                    <CommentModal reader={reader} comment={comment} popupState={popupState} />
                  </MenuItem>

                  <MenuItem
                    sx={{
                      width: '100%',
                    }}
                    data-testid="popup-menu-list-item-reopen"
                  >
                    <ApproveModal task_id={task_id} study_id={study_id} popupState={popupState} />
                  </MenuItem>
                  <MenuItem
                    sx={{
                      width: '100%',
                    }}
                    data-testid="popup-menu-list-item-reset"
                  >
                    <DeclineModal task_id={task_id} study_id={study_id} popupState={popupState} />
                  </MenuItem>
                </Fragment>
              ) : (
                <Fragment>
                  <MenuItem
                    sx={{
                      width: '100%',
                    }}
                    data-testid="popup-menu-list-item-reopen"
                  >
                    <ReopenModal
                      read_task_id={task_id}
                      read_pseudo_id={read_pseudo_id}
                      study_id={study_id}
                      popupState={popupState}
                    />
                  </MenuItem>

                  <MenuItem
                    sx={{
                      width: '100%',
                    }}
                    data-testid="popup-menu-list-item-reopen"
                  >
                    <CopyReReadModal task_id={task_id} study_id={study_id} popupState={popupState} />
                  </MenuItem>

                  <MenuItem
                    sx={{
                      width: '100%',
                    }}
                    data-testid="popup-menu-list-item-reopen"
                  >
                    <CopyEmptyReReadModal task_id={task_id} study_id={study_id} popupState={popupState} />
                  </MenuItem>

                  <MenuItem
                    sx={{
                      width: '100%',
                    }}
                    data-testid="popup-menu-list-item-reopen"
                  >
                    <CopyIntraReadModal task_id={task_id} study_id={study_id} popupState={popupState} />
                  </MenuItem>
                </Fragment>
              )}
            </MenuList>
          </Menu>
        </Fragment>
      )}
    </PopupState>
  )
}
